<template>
  <div class="wrapper">
    <div class="animated fadeIn">
    <b-row>
      <b-col>
        <!-- <b-card header="Preview match">
          <div v-html="replaceTemplateVar" @click.prevent="bannerPreview"></div>
        </b-card> -->
        <b-card header="Edit match">
          <form action="" method="PATCH" enctype="multipart/form-data" class="uploadImage">
              <b-row>
              <b-col sm="6">
                <b-form-group>
                  <label for="home_name" class="text-info">HOME TEAM NAME</label>
                  <b-form-input type="text" class="form-control" id="home_name" placeholder="Ex: Real Madrid" v-model="home_name" required></b-form-input>
                  <div class="invalid-feedback d-block" v-show="errors.home_name">{{ errors.home_name }}</div>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <label for="away_name" class="text-info">AWAY TEAM NAME</label>
                  <b-form-input type="text" class="form-control" id="away_name" placeholder="Ex: Real Madrid" v-model="away_name" required></b-form-input>
                  <div class="invalid-feedback d-block" v-show="errors.away_name">{{ errors.away_name }}</div>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <label class="text-info my-2 text-center d-block">ODDS COMPARISON</label>
                <b-form-group>
                  <label for="book1_name" class="text-info">BOOKMAKER NAME 1</label>
                  <b-form-input type="text" class="form-control" id="book1_name" placeholder="Ex: bet365" v-model="odds['bet365']['_attributes']['name']" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label for="book1_odd_1" class="text-info">ODD 1</label>
                  <b-form-input type="text" class="form-control" id="book1_odd_1" placeholder="Ex: 2.20" v-model="odds['bet365'].odd[0]['_attributes']['value']" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label for="book1_odd_x" class="text-info">ODD X</label>
                  <b-form-input type="text" class="form-control" id="book1_odd_x" placeholder="Ex: 2.20" v-model="odds['bet365'].odd[2]['_attributes']['value']" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label for="book1_odd_2" class="text-info">ODD 2</label>
                  <b-form-input type="text" class="form-control" id="book1_odd_2" placeholder="Ex: 2.20" v-model="odds['bet365'].odd[1]['_attributes']['value']" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <hr>
                <b-form-group>
                  <label for="book2_name" class="text-info">BOOKMAKER NAME 2</label>
                  <b-form-input type="text" class="form-control" id="book2_name" placeholder="Ex: bet365" v-model="odds['888Sport']['_attributes']['name']" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label for="book2_odd_1" class="text-info">ODD 1</label>
                  <b-form-input type="text" class="form-control" id="book2_odd_1" placeholder="Ex: 2.20" v-model="odds['888Sport'].odd[0]['_attributes']['value']" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label for="book2_odd_x" class="text-info">ODD X</label>
                  <b-form-input type="text" class="form-control" id="book2_odd_x" placeholder="Ex: 2.20" v-model="odds['888Sport'].odd[2]['_attributes']['value']" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label for="book2_odd_2" class="text-info">ODD 2</label>
                  <b-form-input type="text" class="form-control" id="book2_odd_2" placeholder="Ex: 2.20" v-model="odds['888Sport'].odd[1]['_attributes']['value']" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <hr>
                <b-form-group>
                  <label for="book3_name" class="text-info">BOOKMAKER NAME 3</label>
                  <b-form-input type="text" class="form-control" id="book3_name" placeholder="Ex: bet365" v-model="odds['bwin']['_attributes']['name']" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label for="book3_odd_1" class="text-info">ODD 1</label>
                  <b-form-input type="text" class="form-control" id="book3_odd_1" placeholder="Ex: 2.20" v-model="odds['bwin'].odd[0]['_attributes']['value']" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label for="book3_odd_x" class="text-info">ODD X</label>
                  <b-form-input type="text" class="form-control" id="book3_odd_x" placeholder="Ex: 2.20" v-model="odds['bwin'].odd[2]['_attributes']['value']" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label for="book3_odd_2" class="text-info">ODD 2</label>
                  <b-form-input type="text" class="form-control" id="book3_odd_2" placeholder="Ex: 2.20" v-model="odds['bwin'].odd[1]['_attributes']['value']" required></b-form-input>
                </b-form-group>
              </b-col>
               <b-col sm="4">
                  <b-form-group>
                    <label for="draft" class="text-info">Draft</label>
                    <b-form-select id="draft" name="drFT" v-model="draft" required>
                        <option value=false>False</option>
                        <option value=true>True</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              <b-col sm="12">
                <hr>
                <button id="publish" type="submit" class="btn btn-danger" @click.prevent="editMatch(match._id)">Update</button>
              </b-col>
            </b-row>
          </form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Edit',
  data () {
    return {
      match: {},
      draft: true,
      home_name: '',
      away_name: '',
      odds: {
        bet365: {
          _attributes: {
            id: '',
            name: 'bet365'
          },
          odd: [
            {
              _attributes: {
                name: '1',
                value: ''
              }
            },
            {
              _attributes: {
                name: '2',
                value: ''
              }
            },
            {
              _attributes: {
                name: 'X',
                value: ''
              }
            }
          ]
        },
        '888Sport': {
          _attributes: {
            id: '',
            name: '888Sport'
          },
          odd: [
            {
              _attributes: {
                name: '1',
                value: ''
              }
            },
            {
              _attributes: {
                name: '2',
                value: ''
              }
            },
            {
              _attributes: {
                name: 'X',
                value: ''
              }
            }
          ]
        },
        bwin: {
          _attributes: {
            id: '',
            name: 'bwin'
          },
          odd: [
            {
              _attributes: {
                name: '1',
                value: ''
              }
            },
            {
              _attributes: {
                name: '2',
                value: ''
              }
            },
            {
              _attributes: {
                name: 'X',
                value: ''
              }
            }
          ]
        }
      },
      errors: {}
    }
  },
  methods: {
    getBanner () {
      const id = this.$route.params.id
      this.$http.get(`${this.$api_url}/matches/edit/${id}`).then((match) => {
        if (match) {
          console.log(match)
          this.home_name = match.data.home_name
          this.away_name = match.data.away_name
          this.odds.bet365 = match.data.odds?.bet365 ? match.data.odds?.bet365 : this.odds.bet365
          this.odds.bwin = match.data.odds?.bwin ? match.data.odds?.bwin : this.odds.bwin
          this.odds['888Sport'] = match.data.odds?.['888Sport'] ? match.data.odds?.['888Sport'] : this.odds['888Sport']
          this.match = match.data
          this.draft = match.data.draft
        }
      })
    },
    editMatch (id) {
      const formData = new FormData()
      this.errors = {}

      formData.append('home_name', this.home_name)
      formData.append('away_name', this.away_name)
      formData.append('odds', JSON.stringify(this.odds))
      formData.append('draft', this.draft)

      if (Object.keys(this.errors).length === 0) {
        this.$http.patch(`${this.$api_url}/matches/edit/${id}`, formData)
          .then((match) => {
            if (confirm('Match updated! Navigate to the manage page?')) {
              this.$router.push('/matches/manage')
            }
          })
      } else {
        this.errors.general = 'Check the required fields!'
      }
    }
  },
  computed: {
    ...mapGetters(['countries', 'XMPhtml', 'apiKey'])
  },
  created () {
    this.getBanner()
  },
  beforeDestroy () {
    //
  }
}
</script>

<style scoped>

</style>
